module.exports = __webpack_public_path__ + "img/2.9bc32145.jpg";